const initialState = {
  sidebarShow: true,
  sidebarUnfoldable: false,
  // sidebarShow: 'responsive',
}

const themes = (state = initialState, { type, ...payload }) => {
  switch (type) {
    case 'set':
      return { ...state, ...payload }
    default:
      return state
  }
}

export default themes
